import Vue from "vue";
import Router from "vue-router";
import { isMiniprogram } from "@/utils/environment";
import { wxHideOptionMenu } from "@/utils/wxConfig";
import { getHash } from "@/utils/util";
import { getToken, setToken, getDoctorId, saveShareId } from "@/utils/storage";
import { dealCache } from "./featuresFn";
import store from "@/store";

const Index = () => import(/* webpackChunkName: "Index" */ "../views/index/Index.vue");
// const OldIndex = () => import(/* webpackChunkName: "Index" */ "../views/index/OldIndex");
const SearchIndex = () => import(/* webpackChunkName: "Index" */ "../views/index/SearchIndex.vue");
const UserBind = () => import("../views/user/UserBind");
const UserLogin = () => import("../views/user/UserLogin");
const YunZhiSign = () => import("../views/user/YunZhiSign");
const YunZhiUserLogin = () => import("../views/user/YunZhiUserLogin");
const YunZhiSignResult = () => import("../views/user/YunZhiSignResult");
const YunZhiHome = () => import("../views/user/YunZhiHome");
const UserLogOff = () => import("../views/user/UserLogOff");
const UserAgreement = () => import("../views/user/UserAgreement");
const KnowledgeDetail = () => import("../views/knowledge/knowledge.vue");
const UserEntry = () => import("../views/entry/UserEntry.vue");
const CarryTokenEntry = () => import("../views/entry/CarryTokenEntry");
const PageTip = () => import("../views/entry/PageTip");
const ScanRepEntry = () => import("../views/entry/ScanRepEntry");
const ThirdUserEntry = () => import("../views/entry/ThirdUserEntry");
const UserUploadAuth = () => import("../views/user/UserUploadAuth.vue");
const UserEdit = () => import("../views/user/UserEdit");
const ModifyInformation = () => import("../views/user/ModifyInformation.vue");
const IdCardUpload = () => import("../views/user/IdCardUpload");
const FaceAuthResult = () => import("../views/user/FaceAuthResult");
const Help = () => import("../views/mine/Help");
const QuestionDetail = () => import("../views/help/QuestionDetail");
const HelpSearch = () => import("../views/help/HelpSearch");
const UserChangeMobile = () => import("../views/user/UserChangeMobile");
const UserSelectFindMobile = () => import("../views/user/UserSelectFindMobile");
const UserBindPhoneSuccess = () => import("../views/user/UserBindPhoneSuccess");
const Feedback = () => import("../views/help/Feedback");
const UserManual = () => import("../views/help/UserManual");
const ProblemList = () => import("../views/mine/ProblemList.vue");
const ProblemDetail = () => import("../views/mine/Problem.vue");
const GiftDetail = () => import("../views/mine/GiftDetail.vue");
const OrderList = () => import(/* webpackChunkName: "orders" */ "../views/mine/OrderList.vue");
const OrderDetail = () => import("../views/mine/OrderDetail");
const ContactService = () => import("../views/mine/ContactService");
const EditAddress = () => import("../views/mine/EditAddress");
const AddressList = () => import("../views/mine/AddressList");
const shopList = () => import(/* webpackChunkName: "ShopList" */ "../views/shop/ShopList.vue");
const SecondsShopList = () => import(/* webpackChunkName: "ShopList" */ "../views/shop/SecondsShopList.vue");
const shopDetail = () => import("../views/shop/ShopDetail");
const shopSettlement = () => import("../views/shop/ShopSettlement");
const ShopSearch = () => import("../views/shop/ShopSearch");
const SearchFeedback = () => import("../views/shop/SearchFeedback");
const ShopPaySuc = () => import("../views/shop/ShopPaySuc");
const ShopAddressList = () => import("../views/shop/ShopAddressList");
const CallCharge = () => import("../views/shop/CallCharge");
const RechargeSuccess = () => import("../views/shop/RechargeSuccess");
const ShopCart = () => import(/* webpackChunkName: "ShopCart" */ "../views/shop/ShopCart.vue");
const Delivery = () => import("../views/shop/Delivery");
const grabRedPacket = () => import("../views/activity/GrabRedPacket");
const ExchangeSuccess = () => import("../views/activity/ExchangeSuccess");
const PatientList = () => import("@/views/patient/PatientList");
const PatientConsultList = () => import("@/views/patient/PatientConsultList");
const PatientConsultDetail = () => import("@/views/patient/PatientConsultDetail");
const PatientUserDetail = () => import("@/views/patient/PatientUserDetail");
const QuestionnaireDetail = () => import("../views/questionnaire/QuestionnaireDetailInfo.vue");
const QuestionnaireDetailPreview = () => import("../views/questionnaire/QuestionnaireDetailInfoPreview");
const ArticleDetail = () => import("../views/questionnaire/ArticleDetail");
const RegisterDetail = () => import("../views/questionnaire/RegisterDetail");
const RegisterDetailPreview = () => import("../views/questionnaire/RegisterDetailPreview");
const PreviewPureQuestionnaire = () => import("../views/preview-questionnaire/PreviewPureQuestionnaire");

const AccpetQuestionnaire = () => import("../views/questionnaire/AccpetQuestionnaire");

const SpecialShopList = () => import("../views/shop/SpecialShopList");
const ConferenceDetail = () => import(/* webpackChunkName: "Index" */ "../views/conference/ConferenceDetail.vue");
const SystemMessage = () => import("../views/system/SystemMessage.vue");
const EditPharmacyPreview = () => import("../views/system/EditPharmacyPreview.vue");
const Live = () => import("../views/live/Live.vue");
const Webinar = () => import("../views/live/Webinar");
const weapp = () => import("../views/live/WeApp");
const SpeakerConsole = () => import("../views/live/SpeakerConsole");
const SearchCouldPage = () => import("../views/find/SearchCouldPage");
const AcademicDefault = () => import("../views/find/AcademicDefault");
const SpeakerInvite = () => import("../views/find/SpeakerInvite");
const SpeakerRoom = () => import("../views/find/SpeakerRoom.vue");
const PodcastInviteDetail = () => import("../views/find/PodcastInviteDetail.vue");
const PodcastApply = () => import("../views/find/PodcastApply.vue");
const PodcastFlow = () => import("../views/find/PodcastFlow.vue");
const LiveHistory = () => import("../views/mine/LiveHistoryList.vue");
const SpeakerGiftDetail = () => import("../views/find/SpeakerGiftDetail");
const SpeakerGiftCash = () => import("../views/find/SpeakerGiftCash");
const SpeakerPlatformLaborCash = () => import("../views/find/SpeakerPlatformLaborCash");
const SpeakerLiveGift = () => import("../views/find/SpeakerLiveGift");
const speakerCashDetail = () => import("../views/find/speakerCashDetail");
const TaxationCalculator = () => import("../views/find/TaxationCalculator.vue");
const PartnerAgree = () => import("../views/mine/PartnerAgree");
const LabourAgree = () => import("../views/mine/LabourAgree");
const TianjinAgree = () => import("../views/mine/TianjinAgree");
const SpeakerAgree = () => import("../views/mine/SpeakerAgree");
const SpecialSpeakerAgree = () => import("../views/mine/SpecialSpeakerAgree");
// ---------------- 混合支付 start --------------------------
const PayHome = () => import("../views/pay/payHome.vue");
const PayResult = () => import("../views/pay/payResult.vue");
// ---------------- 混合支付 end ----------------------------
// webinar 多人会议
const QxsUserProtocol = () => import("../views/user/QxsUserProtocol");
const QxsUserPrivacy = () => import("../views/user/QxsUserPrivacy");
// ---------------------- 新拜访 -------------------------
const NewVisitDetail = () => import("../views/visit/NewVisitDetail.vue");
const newVisitVideoDetail = () => import("../views/visit/NewVisitVideoDetail");
const NotFound = () => import("../views/notfound/NotFound");
// ---------------------- 在线互动病例征集 -------------------------
const InteractiveCaseActivityDetail = () => import("../views/interactive-case/activity-detail.vue");
const InteractiveCaseCreationProcess = () => import("../views/interactive-case/creation-process.vue");
// ------------------------ 知识店铺 -----------------------
const KnowledgeRoom = () => import("@/views/knowledgeRoom/KnowledgeRoom");
const SearchKnowledge = () => import("@/views/knowledgeRoom/SearchKnowledge");
const HaveBuy = () => import("@/views/knowledgeRoom/HaveBuy");
const HaveAttention = () => import("@/views/knowledgeRoom/HaveAttention");
const IntellectualDetail = () => import("@/views/knowledgeRoom/IntellectualDetail");
const PersonalShop = () => import("@/views/knowledgeRoom/PersonalShop");
const CollectList = () => import("@/views/knowledgeRoom/CollectList");
const SpeakerRmbAmount = () => import("@/views/knowledgeRoom/SpeakerRmbAmount");
const BeanAmount = () => import("@/views/knowledgeRoom/BeanAmount");
const IntellectualDeposit = () => import("@/views/knowledgeRoom/IntellectualDeposit");
const PayCourseHome = () => import("@/views/knowledgeRoom/PayCourseHome");
const PayCourseResult = () => import("@/views/knowledgeRoom/PayCourseResult");
const KnowledgeCourseList = () => import("@/views/knowledgeRoom/KnowledgeCourseList");
const UserSupportCenter = () => import("@/views/user/UserSupportCenter");
const UserApplyUnseal = () => import("@/views/user/UserApplyUnseal");
const UserRetrieveMobile = () => import("@/views/user/UserRetrieveMobile");
const UserRecallGiftDetail = () => import("@/views/user/UserRecallGiftDetail");
const UserFaceAuthPage = () => import("@/views/user/UserFaceAuthPage");
// ----------------------------- 售后服务 -----------------------------------
const CantAfterSales = () => import("@/views/mine/CantAfterSales");
const OrderAfterSales = () => import("@/views/mine/OrderAfterSales");
const OrderAfterSalesDetail = () => import("@/views/mine/OrderAfterSalesDetail");
const OrderAfterSalesReview = () => import("@/views/mine/OrderAfterSalesReview");
const ApplyAfterSales = () => import("@/views/mine/ApplyAfterSales");
const SubmitAfterSales = () => import("@/views/mine/SubmitAfterSales");
const RiskResult = () => import("@/views/RiskControl/RiskResult");
// ----------------------------- 活动 -----------------------------------
const SixOneEight = () => import("@/views/activity/SixOneEight");

const DaVisitShare = () => import("@/views/daVisit/share.vue");


// 解决路由 push/replace 相同地址报错的问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => err);
};

Vue.use(Router);

// 需要判断运行环境是否是在小程序
const routerFun = async () => {
  // 小程序停用公告 start
  let isWXTip = false;
  typeof window.__isMiniprogram === "undefined" ? (isWXTip = await isMiniprogram()) : (isWXTip = window.__isMiniprogram);
  if (isWXTip) {
    const index = new Router({
      mode: "history",
      routes: [
        {
          path: "*",
          name: "PageTip",
          component: PageTip,
          meta: {
            title: "系统公告",
            requiresAuth: false,
            keepAlive: false,
          },
        },
      ],
    });
    return index;
  }
  // 小程序停用公告 end
  const index = new Router({
    mode: "history",
    routes: [
      {
        path: "/",
        name: "home",
        component: UserEntry,
        meta: {
          title: "",
          requiresAuth: false,
          keepAlive: false,
        },
      },
      {
        path: "/transfer",
        name: "transfer",
        component: UserEntry,
        meta: {
          title: "",
          requiresAuth: false,
          keepAlive: false,
        },
      },
      {
        path: "/carry/entry/:token",
        name: "CarryTokenEntry",
        component: CarryTokenEntry,
        meta: {
          title: "",
          requiresAuth: false,
          keepAlive: false,
        },
      },
      {
        path: "/third-user/entry",
        name: "ThirdUserEntry",
        component: ThirdUserEntry,
        meta: {
          title: "",
          requiresAuth: false,
          keepAlive: false,
        },
      },
      {
        path: "/scan-rep/entry",
        name: "ScanRepEntry",
        component: ScanRepEntry,
        meta: {
          title: "",
          requiresAuth: false,
          keepAlive: false,
        },
      },
      {
        path: "/bind",
        name: "bind",
        component: UserBind,
        meta: {
          title: "绑定",
          requiresAuth: false,
          keepAlive: false,
        },
      },
      {
        path: "/login",
        name: "login",
        component: UserLogin,
        meta: {
          title: "登录",
          requiresAuth: false,
          keepAlive: false,
        },
      },
      {
        path: "/yunzhi-login",
        name: "YunZhiUserLogin",
        component: YunZhiUserLogin,
        meta: {
          title: "云智登录",
          requiresAuth: false,
          keepAlive: false,
        },
      },
      {
        path: "/yunzhi-sign",
        name: "YunZhiSign",
        component: YunZhiSign,
        meta: {
          title: "认证",
          requiresAuth: false,
          keepAlive: false,
          cache: ["SpeakerAgree"]
        },
      },
      {
        path: "/yunzhi-sign-result",
        name: "YunZhiSignResult",
        component: YunZhiSignResult,
        meta: {
          title: "签约结果",
          requiresAuth: false,
          keepAlive: false,
        },
      },
      {
        path: "/yunzhi-home",
        name: "YunZhiHome",
        component: YunZhiHome,
        meta: {
          title: "云智服务中心",
          requiresAuth: false,
          keepAlive: false,
        },
      },
      {
        path: "/logoff",
        name: "UserLogOff",
        component: UserLogOff,
        meta: {
          title: "账号注销",
          requiresAuth: false,
          keepAlive: false,
        },
      },
      {
        path: "/agreen",
        name: "UserAgreement",
        component: UserAgreement,
        meta: {
          title: "用户协议",
          requiresAuth: false,
          keepAlive: false,
        },
      },
      {
        path: "/user/edit",
        name: "userEdit",
        component: UserEdit,
        meta: {
          title: "个人信息",
          requiresAuth: true,
          keepAlive: false,
        },
      },
      {
        path: "/user/support/center",
        name: "UserSupportCenter",
        component: UserSupportCenter,
        meta: {
          title: "用户保护中心",
          requiresAuth: true,
          keepAlive: false,
        },
      },
      {
        path: "/user/apply/unseal",
        name: "UserApplyUnseal",
        component: UserApplyUnseal,
        meta: {
          title: "",
          requiresAuth: true,
          keepAlive: false,
        },
      },
      {
        path: '/common/case-practice/:activityQuestId',
        name: 'CasePractice',
        component: () => import('@/views/common-pages/case-practice/index.vue'),
        meta: {
          title: '案例实战',
        }
      },
      {
        path: '/common/case-practice-answer/:activityQuestId',
        name: 'CasePracticeAnswer',
        component: () => import('@/views/common-pages/case-practice/case-answer.vue'),
        meta: {
          title: '案例实战',
        }
      },
      {
        path: '/common/case-practice-detail/:activityQuestId',
        name: 'CasePracticeDetail',
        component: () => import('@/views/common-pages/case-practice/detail.vue'),
        meta: {
          title: '病例实战详情',
          cache: ['CasePracticeExamComment']
        }
      },{
        path: '/common/case-practice-exam-comment/:examId',
        name: 'CasePracticeExamComment',
        component: () => import('@/views/common-pages/case-practice/exam-comment.vue'),
        meta: {
          title: '病例实战评论'
        }
      },
      {
        path: '/interactive-case/activity/:id',
        name: 'InteractiveCaseActivityDetail',
        component: () => import('@/views/interactive-case/activity-detail.vue'),
        meta: {
          title: '活动详情',
          requiresAuth: true,
          keepAlive: false,
        }
      },
      {
        path: '/interactive-case/activity/:id/process',
        name: 'InteractiveCaseCreationProcess',
        component: () => import('@/views/interactive-case/creation-process.vue'),
        meta: {
          title: '创作流程',
          requiresAuth: true,
          keepAlive: false,
        }
      },
      {
        path: "/user/face/auth",
        name: "UserFaceAuthPage",
        component: UserFaceAuthPage,
        meta: {
          title: "人脸识别",
          requiresAuth: true,
          keepAlive: false,
        },
      },
      {
        path: "/user/retrieve/mobile",
        name: "UserRetrieveMobile",
        component: UserRetrieveMobile,
        meta: {
          title: "原手机号已停用",
          requiresAuth: false,
          keepAlive: false,
        },
      },
      {
        path: "/user/recall-gift/center",
        name: "UserRecallGiftDetail",
        component: UserRecallGiftDetail,
        meta: {
          title: "退回积分",
          requiresAuth: true,
          keepAlive: false,
        },
      },
      {
        path: "/user/recall-live/center",
        name: "UserRecallLiveDetail",
        component: UserRecallGiftDetail,
        meta: {
          title: "退回视频服务费",
          requiresAuth: true,
          keepAlive: false,
        },
      },
      {
        path: "/mine/kits",
        name: "kit",
        component: GiftDetail,
        meta: {
          title: "我的积分",
          requiresAuth: true,
          keepAlive: false,
        },
      },
      {
        path: "/mine/orders",
        name: "orderlist",
        component: OrderList,
        meta: {
          title: "我的订单",
          requiresAuth: true,
          cache: ["orderDetail", "Delivery", "ShopCart"],
        },
      },
      {
        path: "/mine/orderDetail/:id",
        name: "orderDetail",
        component: OrderDetail,
        meta: {
          title: "订单详情",
          requiresAuth: true,
          keepAlive: true,
        },
      },
      {
        path: "/mine/contact/service",
        name: "contactService",
        component: ContactService,
        meta: {
          title: "订单详情",
          requiresAuth: true,
          keepAlive: true,
        },
      },
      {
        path: "/mine/problem",
        name: "problem",
        component: ProblemList,
        meta: {
          title: "我的问题",
          requiresAuth: true,
          keepAlive: true,
        },
      },
      {
        path: "/mine/problem/detail/:id",
        name: "problemDetail",
        component: ProblemDetail,
        meta: {
          title: "提问详情",
          requiresAuth: true,
          keepAlive: false,
        },
      },
      {
        path: "/auth/upload",
        name: "UserUploadAuth",
        component: UserUploadAuth,
        meta: {
          title: "趣宣讲身份认证",
          requiresAuth: true,
          keepAlive: false,
        },
      },
      {
        path: "/index",
        name: "Index",
        component: Index,
        meta: {
          title: "首页"
        },
        children: [
          {
            path: "",
            name: "FeedList",
            component: () => import("../views/index/FeedList.vue"),
            meta: {
              title: "推荐",
              requiresAuth: true,
              cache: [
                "SearchIndex",
                "ConferenceDetail",
                "PodcastDetail",
                "QuestionnaireDetail",
                "Live",
                "WebinarDetail",
                "NewVisitDetail",
                "KnowledgeDetail",
                "NewVisitVideoDetail",
                'PodcastInviteDetail',
                "CouldPage",
                'ArticleDetail',
                'RegisterDetail',
                'PreviewPureQuestionnaire'
              ]
            },
          },
          {
            path: "activity",
            name: "ActivityList",
            component: () => import("../views/index/ActivityList.vue"),
            meta: {
              title: "活动",
              requiresAuth: true,
              cache: [
                "SearchIndex",
                "ConferenceDetail",
                "PodcastDetail",
                "QuestionnaireDetail",
                "Live",
                "WebinarDetail",
                "NewVisitDetail",
                "KnowledgeDetail",
                "NewVisitVideoDetail",
                'PodcastInviteDetail',
                'ArticleDetail',
                'RegisterDetail',
                'PreviewPureQuestionnaire'
              ],
            },
          },
          {
            path: "survey",
            name: "SurveyList",
            component: () => import("../views/index/SurveyList.vue"),
            meta: {
              title: "调研",
              requiresAuth: true,
              cache: [
                "SearchIndex",
                "ConferenceDetail",
                "PodcastDetail",
                "QuestionnaireDetail",
                "Live",
                "WebinarDetail",
                "NewVisitDetail",
                "KnowledgeDetail",
                "NewVisitVideoDetail",
                'PodcastInviteDetail',
                'ArticleDetail',
                'RegisterDetail',
                'PreviewPureQuestionnaire'
              ],
            },
          },
        ]
      },
      {
        path: "/search/index",
        name: "SearchIndex",
        component: SearchIndex,
        meta: {
          title: "搜索",
          requiresAuth: true,
          keepAlive: true,
          cache: [
            "SearchIndex",
            "ConferenceDetail",
            "PodcastDetail",
            "QuestionnaireDetail",
            "Live",
            "WebinarDetail",
            "NewVisitDetail",
            "KnowledgeDetail",
            "NewVisitVideoDetail",
            'PodcastInviteDetail',
            'ArticleDetail',
            'RegisterDetail',
            'PreviewPureQuestionnaire'
          ],
        },
      },
      {
        path: "/patient/consult",
        name: "patientConsultList",
        component: PatientConsultList,
        meta: {
          title: "咨询列表",
          requiresAuth: true,
          keepAlive: true,
        },
        children: [
          {
            path: ":id",
            name: "patientConsultDetail",
            component: PatientConsultDetail,
            meta: {
              title: "对话",
              requiresAuth: true,
              keepAlive: true,
            },
          },
        ],
      },
      {
        path: "/patient/user",
        name: "patientUserDetail",
        component: PatientUserDetail,
        meta: {
          title: "患者主页",
          requiresAuth: true,
          keepAlive: true,
        },
        children: [
          {
            path: "consult/:id",
            name: "patientUserConsultDetail",
            component: PatientConsultDetail,
            meta: {
              title: "对话",
              requiresAuth: true,
              keepAlive: true,
            },
          },
        ],
      },
      {
        path: "/mine",
        name: "mine",
        component: () => import("../views/mine/Mine.vue"),
        meta: {
          title: "个人中心",
          requiresAuth: true,
          keepAlive: true,
        },
      },
      {
        path: "/address/list",
        name: "addressList",
        component: AddressList,
        meta: {
          title: "我的地址",
          requiresAuth: true,
          keepAlive: true,
        },
      },
      {
        path: "/address/edit/:id",
        name: "editAddress",
        component: EditAddress,
        meta: {
          title: "编辑地址",
          requiresAuth: true,
          keepAlive: false,
        },
      },
      {
        path: "/address/create",
        name: "createAddress",
        component: EditAddress,
        meta: {
          title: "新建地址",
          requiresAuth: true,
          keepAlive: false,
        },
      },
      {
        path: "/knowledge/:id",
        name: "KnowledgeDetail",
        component: KnowledgeDetail,
        meta: {
          title: "",
          requiresAuth: true,
          keepAlive: false,
        },
      },
      {
        path: "/shop/list",
        name: "shopList",
        component: shopList,
        meta: {
          title: "医者之家",
          requiresAuth: true,
          keepAlive: true,
          cache: ["shopDetail"],
        },
      },
      {
        path: "/seconds/shop/list",
        name: "SecondsShopList",
        component: SecondsShopList,
        meta: {
          title: "秒杀活动",
          requiresAuth: true,
          cache: ["shopDetail"],
        },
      },
      {
        path: "/shop/special/:id",
        name: "specialShop",
        component: SpecialShopList,
        meta: {
          title: "专题列表",
          requiresAuth: true,
          keepAlive: false,
        },
      },
      {
        path: "/shop/detail/:id",
        name: "shopDetail",
        component: shopDetail,
        meta: {
          title: "",
          requiresAuth: true,
          keepAlive: false,
          prePage: ["shopList", "SecondsShopList"], // 上一页
        },
      },
      {
        path: "/shop/settlement",
        name: "shopSettlement",
        component: shopSettlement,
        meta: {
          title: "商品结算",
          requiresAuth: true,
          keepAlive: false,
        },
      },
      {
        path: "/shop/search",
        name: "ShopSearch",
        component: ShopSearch,
        meta: {
          title: "搜索",
          requiresAuth: true,
          keepAlive: true,
        },
      },
      {
        path: "/search/feedback",
        name: "SearchFeedback",
        component: SearchFeedback,
        meta: {
          title: "搜索反馈",
          requiresAuth: false,
          keepAlive: false,
        },
      },
      {
        path: "/settlement/success",
        name: "shopPaySuc",
        component: ShopPaySuc,
        meta: {
          title: "支付结果",
          keepAlive: false,
        },
      },
      {
        path: "/shop/address/:id",
        name: "ShopAddressList",
        component: ShopAddressList,
        meta: {
          title: "地址选择",
          keepAlive: true,
        },
      },
      {
        path: "/shop/recharge",
        name: "CallCharge",
        component: CallCharge,
        meta: {
          title: "话费充值兑换",
          keepAlive: true,
        },
      },
      {
        path: "/recharge/success",
        name: "rechargeSuccess",
        component: RechargeSuccess,
        meta: {
          title: "充值成功",
          keepAlive: true,
        },
      },
      {
        path: "/shop/cart",
        name: "ShopCart",
        component: ShopCart,
        meta: {
          title: "购物车",
          keepAlive: true,
          cache: ["EditAddress", "ShopDetail"],
        },
      },
      {
        path: "/shop/delivery/:id",
        name: "Delivery",
        component: Delivery,
        meta: {
          title: "物流详情",
          keepAlive: true,
        },
      },
      {
        path: "/activity/redPacket",
        name: "grabRedPacket",
        component: grabRedPacket,
        meta: {
          title: "微信红包兑换",
          keepAlive: true,
        },
      },
      {
        path: "/activity/exchange-success",
        name: "exchangeSuccess",
        component: ExchangeSuccess,
        meta: {
          title: "兑换成功",
          keepAlive: true,
        },
      },
      {
        path: "/article/detail/:id",
        name: "ArticleDetail",
        component: ArticleDetail,
        meta: {
          title: "文章",
          keepAlive: true,
        },
      },
      {
        path: "/register/detail/:id",
        name: "RegisterDetail",
        component: RegisterDetail,
        meta: {
          title: "活动报名",
          keepAlive: true,
        },
      },
      // pcc报名预览页面
      {
        path: "/register/detail/preview/:id",
        name: "RegisterDetailPreview",
        component: RegisterDetailPreview,
        meta: {
          title: "活动预览",
          keepAlive: true,
        },
      },
      {
        path: "/questionnaire/detail/:id",
        name: "QuestionnaireDetail",
        component: QuestionnaireDetail,
        meta: {
          title: "问卷",
          keepAlive: true,
        },
      },
      // pcc调研预览页面
      {
        path: "/questionnaire/detail/preview/:id",
        name: "QuestionnaireDetailPreview",
        component: QuestionnaireDetailPreview,
        meta: {
          title: "问卷预览",
          keepAlive: true,
        },
      },
      // 接受调研页面
      {
        path: "/preview/questionnaire/:id",
        name: "PreviewPureQuestionnaire",
        component: PreviewPureQuestionnaire,
        meta: {
          title: "预览调研",
          keepAlive: true,
        },
      },
      {
        path: "/accpet/questionnaire/:id",
        name: "AccpetQuestionnaire",
        component: AccpetQuestionnaire,
        meta: {
          title: "学术调研",
          keepAlive: true,
        },
      },
      {
        path: "/conference/detail/:id",
        name: "ConferenceDetail",
        component: ConferenceDetail,
        meta: {
          title: "",
          requiresAuth: true,
          keepAlive: true,
          cache: ["KnowledgeDetail"],
        },
      },
      {
        path: "/podcast/detail/:id",
        name: "PodcastDetail",
        component: () => import(/* webpackChunkName: "Index" */ "../views/conference/PodcastDetail"),
        meta: {
          title: "",
          requiresAuth: true,
          allowShare: true,
          cache: ["KnowledgeDetail"],
        },
      },
      {
        path: "/live/room/:id",
        name: "Live",
        component: Live,
        meta: {
          title: "",
          requiresAuth: true,
          allowShare: true,
        },
      },
      {
        path: "/open/weapp",
        name: "weapp",
        component: weapp,
        meta: {
          title: "",
          requiresAuth: false,
        },
      },
      {
        path: "/search/could/page",
        name: "SearchCouldPage",
        component: SearchCouldPage,
        meta: {
          title: "搜索",
          requiresAuth: true,
        },
      },
      {
        path: "/find",
        name: "Find",
        component: () => import("../views/find/Find.vue"),
        meta: {
          title: "发现",
          requiresAuth: true
        },
        children: [
          {
            path: "",
            name: "CouldPage",
            component: () => import("../views/find/CouldPage.vue"),
            meta: {
              title: "大咖讲堂",
              requiresAuth: true,
              cache: ["Live", "WebinarDetail", "PodcastDetail", "SpeakerRoom", "SearchCouldPage"]
            },
          },
          {
            path: "patient",
            name: "patientList",
            component: PatientList,
            meta: {
              title: "患者",
              requiresAuth: true,
              cache: ['patientUserDetail']
            },
          },
          {
            path: "speaker/room",
            name: "FindSpeakerRoom",
            component: SpeakerRoom,
            meta: {
              title: "",
              requiresAuth: true,
              cache: ["live", "WebinarDetail", "PodcastDetail", "SpeakerRoom", "SearchCouldPage", 'SpeakerAgree']
            },
          },
        ],
      },
      {
        path: "/taxation-calculator",
        name: "TaxationCalculator",
        component: TaxationCalculator,
        meta: {
          title: "税收计算器",
          requiresAuth: true,
          keepAlive: false
        },
      },
      {
        path: "/podcast/invite/:id",
        name: "PodcastInviteDetail",
        component: PodcastInviteDetail,
        meta: {
          title: "播客邀约",
          requiresAuth: true,
          cache: [
            'PartnerAgree',
            'SpeakerAgree'
          ]
        },
      },
      {
        path: "/podcast/apply",
        name: "PodcastApply",
        component: PodcastApply,
        meta: {
          title: "报名参与",
          requiresAuth: true,
        },
      },
      {
        path: "/podcast/flow",
        name: "PodcastFlow",
        component: PodcastFlow,
        meta: {
          title: "创作流程",
          requiresAuth: true,
        },
      },
      {
        path: "/speaker/room/:id",
        name: "SpeakerRoom",
        component: SpeakerRoom,
        meta: {
          title: "",
          requiresAuth: true,
          cache: [
            'PodcastInviteDetail',
            'Live',
            "WebinarDetail",
          ]
        },
      },
      {
        path: "/academic/default",
        name: "AcademicDefault",
        component: AcademicDefault,
        meta: {
          title: "简介",
          requiresAuth: true,
        },
      },
      // 涉及签约第三方回调，地址不可更改
      {
        path: "/speaker/invite",
        name: "SpeakerInvite",
        component: SpeakerInvite,
        meta: {
          title: "播客认证",
          requiresAuth: false,
        },
      },
      {
        path: "/partner/agree",
        name: "PartnerAgree",
        component: PartnerAgree,
        meta: {
          title: "共享经济合作伙伴协议",
          requiresAuth: true,
        },
      },
      {
        path: "/labour/agree",
        name: "LabourAgree",
        component: LabourAgree,
        meta: {
          title: "自由职业者服务协议",
          requiresAuth: true,
        },
      },
      {
        path: "/tianjin/agree",
        name: "TianjinAgree",
        component: TianjinAgree,
        meta: {
          title: "共享经济智能综合服务协议",
          requiresAuth: true,
        },
      },
      {
        path: "/speaker/agree/:id",
        name: "SpeakerAgree",
        component: SpeakerAgree,
        meta: {
          title: "协议",
          requiresAuth: true,
        },
      },
      {
        path: "/special/speaker/agree",
        name: "SpecialSpeakerAgree",
        component: SpecialSpeakerAgree,
        meta: {
          title: "趣学术项目承揽合作协议",
          requiresAuth: true,
        },
      },
      {
        path: "/speaker/gift/detail",
        name: "SpeakerGiftDetail",
        component: SpeakerGiftDetail,
        meta: {
          title: "视频服务账户",
          requiresAuth: true,
        },
      },
      {
        path: "/speaker/gift/cash",
        name: "SpeakerGiftCash",
        component: SpeakerGiftCash,
        meta: {
          title: "视频服务费提现",
          requiresAuth: true,
        },
      },
      {
        path: "/speaker/platform-labor/cash",
        name: "SpeakerPlatformLaborCash",
        component: SpeakerPlatformLaborCash,
        meta: {
          title: "视频服务费提现",
          requiresAuth: true,
        },
      },
      {
        path: "/speaker/live/gift",
        name: "SpeakerLiveGift",
        component: SpeakerLiveGift,
        meta: {
          title: "趣直播收益",
          requiresAuth: true,
        },
      },
      {
        path: "/speaker/cash/detail/:id",
        name: "speakerCashDetail",
        component: speakerCashDetail,
        meta: {
          title: "收益提现详情",
          requiresAuth: true,
        },
      },
      {
        path: "/live/history",
        name: "LiveHistory",
        component: LiveHistory,
        meta: {
          title: "观看历史",
          requiresAuth: true,
          cache: ['Live']
        },
      },
      {
        path: "/system/message",
        name: "SystemMessage",
        component: SystemMessage,
        meta: {
          title: "系统消息",
          requiresAuth: true,
          cache: ['ModifyInformation']
        },
      },
      {
        path: "/pharmacy/preview/:id",
        name: "EditPharmacyPreview",
        component: EditPharmacyPreview,
        meta: {
          title: "修改信息详情",
          requiresAuth: true,
        },
      },
      {
        path: "/speaker/console/:id",
        name: "SpeakerConsole",
        component: SpeakerConsole,
        meta: {
          title: "讲者聊天",
          requiresAuth: false,
        },
      },
      {
        path: "/pay/home",
        name: "PayHome",
        component: PayHome,
        meta: {
          title: "支付",
          requiresAuth: true,
          keepAlive: false,
          prePage: ["shopSettlement"], // 上一页
        },
      },
      {
        path: "/pay/result",
        name: "PayResult",
        component: PayResult,
        meta: {
          title: "支付结果",
          requiresAuth: true,
          keepAlive: false,
        },
      },
      {
        path: "/modify/information/:id",
        name: "ModifyInformation",
        component: ModifyInformation,
        meta: {
          title: "修改信息详情",
          requiresAuth: true,
          keepAlive: false,
        },
      },
      {
        path: "/idcard/upload",
        name: "IdCardUpload",
        component: IdCardUpload,
        meta: {
          title: "手动身份认证",
          requiresAuth: true,
          keepAlive: false,
        },
      },
      {
        path: "/face/result",
        name: "FaceAuthResult",
        component: FaceAuthResult,
        meta: {
          title: "人脸识别认证",
          requiresAuth: false,
          keepAlive: false,
        },
      },
      {
        path: "/mine/help",
        name: "Help",
        component: Help,
        meta: {
          title: "帮助中心",
          keepAlive: true,
        },
      },
      {
        path: "/help/questiondetail/:id",
        name: "QuestionDetail",
        component: QuestionDetail,
        meta: {
          title: "问题详情",
          keepAlive: false,
        },
      },
      {
        path: "/help/helpsearch",
        name: "helpsearch",
        component: HelpSearch,
        meta: {
          title: "搜索",
          keepAlive: false,
        },
      },
      {
        path: "/user/select/find-type",
        name: "UserSelectFindMobile",
        component: UserSelectFindMobile,
        meta: {
          title: "更换手机号",
          requiresAuth: true,
          keepAlive: false,
        },
      },
      {
        path: "/user/change/mobile",
        name: "UserChangeMobile",
        component: UserChangeMobile,
        meta: {
          title: "更换手机",
          requiresAuth: false,
          keepAlive: false,
        },
      },
      {
        path: "/user/change-mobile/success",
        name: "UserBindPhoneSuccess",
        component: UserBindPhoneSuccess,
        meta: {
          title: "更换手机",
          requiresAuth: false,
          keepAlive: false,
        },
      },
      {
        path: "/help/feedback",
        name: "Feedback",
        component: Feedback,
        meta: {
          title: "吐个槽",
          keepAlive: false,
        },
      },
      {
        path: "/help/usermanual",
        name: "UserManual",
        component: UserManual,
        meta: {
          title: "用户手册",
          keepAlive: false,
        },
      },
      {
        path: "/webinar/room/:id",
        name: "WebinarDetail",
        component: Webinar,
        meta: {
          title: "多人会议",
          requiresAuth: true,
        },
      },
      {
        path: "/qxs/protocol",
        name: "QxsUserProtocol",
        component: QxsUserProtocol,
        meta: {
          title: "趣学术服务协议",
          requiresAuth: false,
        },
      },
      {
        path: "/qxs/privacy",
        name: "QxsUserPrivacy",
        component: QxsUserPrivacy,
        meta: {
          title: "趣学术隐私协议",
          requiresAuth: false,
        },
      },
      // 新拜访
      {
        path: "/new/visit/detail/:id",
        name: "NewVisitDetail",
        component: NewVisitDetail,
        meta: {
          title: "",
          keepAlive: true,
        },
      },
      {
        path: "/new/visit/videodetail/:codeId",
        name: "NewVisitVideoDetail",
        component: newVisitVideoDetail,
        meta: {
          title: "",
          requiresAuth: true,
          keepAlive: false,
        },
      },
      {
        path: '/new/visit/videoParsedetail/:id',
        name: 'NewVisitVideoParsedetail',
        component: () => import('@/views/visit/VideoParseDetail.vue'),
        meta: {
          title: '',
          requiresAuth: true,
          keepAlive: false
        }
      },
      // 知识店铺
      {
        path: "/intellectual/room",
        name: "KnowledgeRoom",
        component: KnowledgeRoom,
        meta: {
          title: "专业医学社区",
          requiresAuth: true,
          keepAlive: true,
        },
      },
      {
        path: "/search/intellectual",
        name: "SearchKnowledge",
        component: SearchKnowledge,
        meta: {
          title: "大咖讲堂-搜索",
          requiresAuth: true,
          keepAlive: true,
        },
      },
      {
        path: "/have/buy",
        name: "HaveBuy",
        component: HaveBuy,
        meta: {
          title: "大咖讲堂-已购课程",
          requiresAuth: true,
          keepAlive: true,
        },
      },
      {
        path: "/have/attention",
        name: "HaveAttention",
        component: HaveAttention,
        meta: {
          title: "大咖讲堂-我的关注",
          requiresAuth: true,
          keepAlive: true,
        },
      },
      {
        path: "/intellectual/detail/:courseId",
        name: "IntellectualDetail",
        component: IntellectualDetail,
        meta: {
          title: "课程详情",
          requiresAuth: false,
          allowShare: !!getToken(),
        },
      },
      {
        path: "/personal/shop/:doctorId",
        name: "PersonalShop",
        component: PersonalShop,
        meta: {
          title: "知识店铺",
          requiresAuth: false,
          keepAlive: true,
          allowShare: true,
        },
      },
      {
        path: "/collect/list",
        name: "CollectList",
        component: CollectList,
        meta: {
          title: "我的收藏",
          requiresAuth: true,
          keepAlive: true,
        },
      },
      {
        path: "/speaker/amount",
        name: "SpeakerRmbAmount",
        component: SpeakerRmbAmount,
        meta: {
          title: "账户余额",
          requiresAuth: true,
        },
      },
      {
        path: "/bean/amount",
        name: "BeanAmount",
        component: BeanAmount,
        meta: {
          title: "趣豆余额",
          requiresAuth: true,
        },
      },
      {
        path: "/intellectual/deposit",
        name: "IntellectualDeposit",
        component: IntellectualDeposit,
        meta: {
          title: "账户提现",
          requiresAuth: true,
        },
      },
      {
        path: "/pay/course/home/:orderId",
        name: "PayCourseHome",
        component: PayCourseHome,
        meta: {
          title: "支付",
          requiresAuth: true,
        },
      },
      {
        path: "/pay/course/result/:orderId",
        name: "PayCourseResult",
        component: PayCourseResult,
        meta: {
          title: "支付结果",
          requiresAuth: true,
        },
      },
      {
        path: "/knowledge/course/list",
        name: "KnowledgeCourseList",
        component: KnowledgeCourseList,
        meta: {
          title: "课程列表",
          requiresAuth: false,
        },
      },
      // ---------------- 售后服务 --------------------
      {
        path: "/cant/after/sales",
        name: "CantAfterSales",
        component: CantAfterSales,
        meta: {
          title: "申请售后",
          requiresAuth: false,
        },
      },
      {
        path: "/after/sales",
        name: "OrderAfterSales",
        component: OrderAfterSales,
        meta: {
          title: "退款/售后",
          requiresAuth: false,
        },
      },
      {
        path: "/after/sales/detail/:id",
        name: "OrderAfterSalesDetail",
        component: OrderAfterSalesDetail,
        meta: {
          title: "售后详情",
          requiresAuth: false,
        },
      },
      {
        path: "/after/sales/review/:id",
        name: "OrderAfterSalesReview",
        component: OrderAfterSalesReview,
        meta: {
          title: "审核处理中",
          requiresAuth: false,
        },
      },
      {
        path: "/apply/after/sales/:id",
        name: "ApplyAfterSales",
        component: ApplyAfterSales,
        meta: {
          title: "申请售后",
          requiresAuth: false,
        },
      },
      {
        path: "/submit/after/sales/:id",
        name: "SubmitAfterSales",
        component: SubmitAfterSales,
        meta: {
          title: "申请退货",
          requiresAuth: false,
        },
      },
      // ---------------------------------- 风控 ------------------------------
      {
        path: "/risk/result",
        name: "RiskResult",
        component: RiskResult,
        meta: {
          title: "风控校验结果",
          requiresAuth: false,
        },
      },
      {
        path: '/risk/verify',
        name: 'FaceVerify',
        component: () => import('@/views/RiskControl/RiskFaceVerify/Index.vue'),
        meta: {
          title: "人脸识别说明",
        },
      },
      {
        path: '/risk/verify/face',
        name: 'FaceVerifyFace',
        component: () => import('@/views/RiskControl/RiskFaceVerify/Face.vue'),
        meta: {
          title: "人脸识别",
        },
      },
      {
        path: '/risk/verify/face-video',
        name: 'FaceVerifyFaceVideo',
        component: () => import('@/views/RiskControl/RiskFaceVerify/FaceVideo.vue'),
        meta: {
          title: "人脸识别",
        },
      },
      {
        path: '/risk/resolve/:results',
        name: 'FaceResolve',
        component: () => import('@/views/RiskControl/RiskFaceVerify/Resolve.vue'),
        meta: {
          title: "人脸识别结果",
        },
      },
      {
        path: '/risk/podcast/verify/:id',
        name: 'PodcastFaceVerify',
        component: () => import('@/views/RiskControl/PodcastFaceVerify.vue'),
        meta: {
          title: "人脸识别说明",
        },
      },
      // ---------------------------------- 活动 ------------------------------
      {
        path: "/activity/618/:id",
        name: "SixOneEight",
        component: SixOneEight,
        meta: {
          title: "618活动",
          requiresAuth: true,
        },
      },
      {
        path: "/clue/da-visit/share",
        name: "DaVisitShare",
        component: DaVisitShare,
        meta: {
          title: "学术Da拜访",
          requiresAuth: true,
        },
      },
      {
        path: '/error',
        name: 'Error',
        component: () => import("@/views/system/error.vue"),
        meta: {
          title: "非微信环境",
        },
      },
      {
        path: "*",
        name: "NotFound",
        component: NotFound,
        meta: {
          title: "页面不存在",
          requiresAuth: false,
        },
      },
    ],
    scrollBehavior(to, from, savedPosition) {
      return new Promise((resolve, reject) => {
        if (savedPosition) {
          resolve(savedPosition);
        } else {
          resolve({ x: 0, y: 0 });
        }
      });
    },
  });

  index.beforeEach(async (to, from, next) => {
    // 处理缓存
    await dealCache(to, from, next, store);
    let AUTH_TOKEN = getHash("token") || to.query.token || to.params.token;
    if ((AUTH_TOKEN && window.location.pathname.indexOf("transfer") > -1) || to.params.token || to.query.token) {
      setToken(AUTH_TOKEN);
      if (window.__bl) {
        const strs = AUTH_TOKEN.split("_");
        const uid = strs[1] || "";
        window.__bl.setConfig({
          uid,
        });
      }
    } else {
      AUTH_TOKEN = getToken();
    }
    let sharerId = to.query.sharerId || to.query.doctorId || "";
    if (sharerId !== getDoctorId()) {
      saveShareId(sharerId);
    }

    if (to.matched.some((record) => record.meta.requiresAuth) && !AUTH_TOKEN) {
      next({
        path: "/transfer",
        query: {
          redirect: to.fullPath,
        },
      });
    } else {
      let allowShare = !!to.meta.allowShare || false;
      if (allowShare) {
        if ((to.query.doctorId == getDoctorId() || !getDoctorId()) && !to.query.sharerId) {
          next();
          return;
        }
        let toQuery = JSON.parse(JSON.stringify(to.query));
        // toQuery.times = new Date().getTime()
        toQuery.doctorId = getDoctorId();
        delete toQuery.sharerId;
        next({
          path: to.path,
          query: toQuery,
        });
      } else {
        next();
      }
    }
  });
  index.afterEach((to, from) => {
    let allowShare = !!to.meta.allowShare || false;
    wxHideOptionMenu(allowShare);
  });
  return index;
};
export default routerFun;
